import * as React from 'react';

import Alert from 'src/components/common/Alert';
import { isMobile } from 'src/utils/responsiveHelpers';
import SlideMenu from 'src/components/common/SlideMenu';
import Modal from 'src/components/common/Modal';

import locationServiceInstance from 'src/services/location/LocationService';
import warehouseServiceInstance from '../../services/warehouse/WarehouseService';
import env from 'src/shared/env';

import './GlobalDeliverAddressChange.scss';
import i18n from 'src/translation/i18n';

interface IDeliverAddress {
  name: string;
  code: string;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
  pickUpOnly: boolean;
}

interface IDeliverAddressChangeProps {
  deliverMethod: string;
  show: boolean;
  showBackorder: boolean;
  showPickUpOnly: boolean;
  handleClose: () => void;
  handleChangeAddress: (selectedAddressCode: string) => void;
  t?: any;
}

interface IDeliverAddressChangeState {
  selectedAddress: string;
  zipCode: string;
  deliverAddresses: IDeliverAddress[];
  allDeliverAddresses: IDeliverAddress[];
  alert: { show: boolean; type: string; message: string };
  isMobile: boolean;
}

class DeliverAddressChange extends React.Component<
  IDeliverAddressChangeProps,
  IDeliverAddressChangeState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedAddress: '',
      zipCode: '',
      deliverAddresses: [],
      allDeliverAddresses: [],
      alert: { show: false, type: '', message: '' },
      isMobile: isMobile()
    };
  }

  private handleOnChangeZIPCode = (e: any) => {
    this.setState({ zipCode: e.target.value });
  };

  private orderAddressesByPickUp = (addresses: IDeliverAddress[]) => {
    const pickUp: IDeliverAddress[] = [];
    const normal: IDeliverAddress[] = [];

    addresses.forEach(address => {
      if (address.pickUpOnly) {
        pickUp.push(address);
      } else {
        normal.push(address);
      }
    });

    return normal.concat(pickUp);
  };

  private handleSearchLocations = () => {
    let newAddresses: any[] = [];
    if (this.state.zipCode) {
      locationServiceInstance
        .getLocations(this.state.zipCode)
        .then(res => {
          if (res) {
            res.forEach(location => {
              this.state.deliverAddresses.forEach(address => {
                if (address.code === location.code) {
                  newAddresses.push({ ...address, ...location });
                }
              });
            });
          }
          if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
            newAddresses = this.orderAddressesByPickUp(newAddresses);
          }
          this.setState({
            deliverAddresses: newAddresses,
            alert: { show: false, type: '', message: '' }
          });
        })
        .catch(err => {
          this.setState({
            alert: {
              show: true,
              type: 'error',
              message: err.response.data.message
            }
          });
        });
    } else {
      this.setState({
        deliverAddresses: this.state.deliverAddresses,
        alert: { show: false, type: '', message: '' }
      });
    }
  };

  private handleOnSelect = (warehouse: string) => {
    const { t } = this.props;
    if (this.props.showBackorder) {
      this.setState({
        selectedAddress: warehouse,
        alert: {
          show: true,
          type: 'info',
          message:
            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? `${t('common.checkAvailabilityTxt')}`
              : `${t('common.availabilityWithShipping')}`
        }
      });
    } else {
      this.setState({
        selectedAddress: warehouse
      });
    }
  };

  private handleCloseAlert = () => {
    this.setState({ alert: { show: false, type: '', message: '' } });
  };

  private formatAddress = (address: IDeliverAddress) => {
    let addressF: string = '';
    addressF +=
      address.addressLine1 && `${address.addressLine1.toLocaleLowerCase()} `;
    addressF +=
      address.addressLine2 && `${address.addressLine2.toLocaleLowerCase()} `;
    addressF +=
      address.addressLine4 && `${address.addressLine4.toLocaleLowerCase()}, `;
    addressF += address.stateCode && `${address.stateCode} `;
    addressF += address.postalCode && `${address.postalCode}`;
    return addressF;
  };

  private renderGlobalDeliverAddress = () => {
    const { t } = this.props;
    return (
      <div className="rp-global-deliver-address-change">
        {this.state.alert.show && (
          <Alert
            type={this.state.alert.type}
            styleClass={'rp-global-deliver-address-change--alert'}
            message={this.state.alert.message}
            icon={
              this.state.alert.type === 'error' ? 'rpds-error' : 'rpds-shipping'
            }
            handleCloseAlert={this.handleCloseAlert}
          />
        )}
        <div className="rp-global-deliver-address-change--info">
          <span
            onClick={e => this.props.handleClose()}
            className="rpds-close rp-global-deliver-address-change--close-modal-icon"
          />
          <div className="rp-global-deliver-address-change--directions-text">
            {this.props.deliverMethod === 'Shipping'
              ? `${t('checkoutPage.chooseShipFromLocation')}:`
              : this.props.showPickUpOnly
              ? `${t('product.choosePickStore')}:`
              : `${t('checkoutPage.chooseShipYourPickup')}:`}
          </div>
          {/* {this.state.allDeliverAddresses.length > 0 &&
            this.state.allDeliverAddresses[0].postalCode && (
              <div className="rp-global-deliver-address-change--zip-code">
                <label>{`
                Enter a ${
                  env.REACT_APP_BASE_ENVIRONMENT === "CA"
                    ? "complete Postal Code"
                    : "ZIP Code"
                }:`}</label>
                <div className="rp-global-deliver-address-change--zip-code-input">
                  <input
                    type="text"
                    onChange={this.handleOnChangeZIPCode}
                    placeholder={
                      env.REACT_APP_BASE_ENVIRONMENT === "CA"
                        ? "Postal Code"
                        : "ZIP Code"
                    }
                    onKeyPress={event => {
                      if (event.key === "Enter") {
                        this.handleSearchLocations();
                      }
                    }}
                  />
                  <button
                    onClick={this.handleSearchLocations}
                    className="primary-button rp-global-deliver-address-change--zip-code-button"
                  >
                    <span className="rpds rpds-search" />
                  </button>
                </div>
              </div>
            )} */}
          <div className="rp-global-deliver-address-change--addresses">
            <div className="rp-global-deliver-address-change--addresses--titles-desktop">
              <div className="rp-global-deliver-address-change--addresses--title-store-desktop">
                {t('product.store')}
              </div>
            </div>
            {this.state.deliverAddresses.length > 0 &&
              this.state.deliverAddresses.map(address => (
                <div key={address.code}>
                  <div className="rp-divider" />
                  {
                    // disable select pick up only addresses on Canada
                  }
                  <div
                    onClick={
                      env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                      this.props.deliverMethod === 'Shipping' &&
                      address.pickUpOnly
                        ? e => null
                        : e => this.handleOnSelect(address.code)
                    }
                    className={`rp-global-deliver-address-change--addresses--row ${this
                      .state.selectedAddress === address.code && 'selected'} ${
                      env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                      this.props.deliverMethod === 'Shipping' &&
                      address.pickUpOnly
                        ? 'disable'
                        : ''
                    }`}
                  >
                    <div className="rp-global-deliver-address-change--addresses--address">
                      <div className="rp-global-deliver-address-change--addresses--title-mobile">
                        {t('product.store')}
                      </div>
                      <div className="rp-global-deliver-address-change--addresses--address--state">
                        {env.REACT_APP_BASE_ENVIRONMENT === 'US'
                          ? address.name.split(' PICK UP ONLY')[0]
                          : address.name}
                      </div>
                      <div className="rp-global-deliver-address-change--addresses--address--complete">
                        {this.formatAddress(address)}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="rp-global-deliver-address-change--button">
            <button
              className="primary-button"
              onClick={e =>
                this.props.handleChangeAddress(this.state.selectedAddress)
              }
            >
              {t('common.changeStore')}
            </button>
          </div>
        </div>
      </div>
    );
  };

  private filterAddresses = (addresses: any[]) => {
    let list: any[] = [];
    if (!this.props.showPickUpOnly && env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
      addresses.forEach(element => {
        if (!element.pickUpOnly) {
          list.push(element);
        }
      });
    } else {
      list = this.orderAddressesByPickUp(addresses); // we are only going to order in Canada
    }

    this.setState({ deliverAddresses: list, allDeliverAddresses: list });
  };

  public componentDidMount() {
    warehouseServiceInstance
      .getWarehouses()
      .then(res => this.filterAddresses(res));
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public render() {
    return this.state.isMobile ? (
      <SlideMenu
        mounted={this.props.show}
        goBackTitle={i18n.t('common.back')}
        level={2 + 30}
        handleCloseMenu={this.props.handleClose}
      >
        {this.renderGlobalDeliverAddress()}
      </SlideMenu>
    ) : (
      this.props.show && (
        <Modal handleCloseModal={this.props.handleClose}>
          {this.renderGlobalDeliverAddress()}
        </Modal>
      )
    );
  }
}

export default DeliverAddressChange;
